import * as React from 'react'
import { FC } from 'react'
import { FormActions } from './typings'
import { EmbeddedForm } from './EmbeddedForm'
import { SettingsPage } from '@sales-center/components'
import { useGetEmbedUrlOnMount } from './hooks/useGetEmbedUrlOnMount'
import { FM_FORM_STATUSES } from '@user/store/agreements/typings'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

interface Props {
  action: FormActions
  formId: number
  title?: string
  onClose: () => void
  onStatusChange?: (status: FM_FORM_STATUSES | undefined) => void
}

export const EmbeddedFormWrapper: FC<Props> = (props: Props) => {
  const { action, formId, title, onClose, onStatusChange } = props
  const [status, url] = useGetEmbedUrlOnMount({
    action,
    formId,
  })

  return (
    <SettingsPage
      title={title}
      fullScreen
      padding="0px"
      preventScroll
      contentHeight={title ? undefined : '100%'}
    >
      {status == 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {status == 'success' && (
        <EmbeddedForm
          onClose={onClose}
          onStatusChange={onStatusChange}
          url={url}
        />
      )}

      {status == 'fail' && (
        <Alert severity="error">
          Failed to load Form Manager agreement editor.
        </Alert>
      )}
    </SettingsPage>
  )
}

EmbeddedFormWrapper.displayName = 'EmbeddedFormWrapper'
